import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { concatMap, tap } from 'rxjs';
import { NgrxService } from 'src/app/services';
import { environment } from 'src/environments/environment';
@Injectable({
	providedIn: 'root',
})
export class StudentsService {
	constructor(private http: HttpClient, private ngrxService: NgrxService) {}

	loadStudentInit(shortCode: string) {
		return this.ngrxService.init('students', 'list', shortCode);
	}

	loadStudentApi(shortCode: string) {
		return this.ngrxService.loadInitAPI('students', 'list', shortCode).pipe(
			concatMap(() =>
				this.http.get(
					environment.url.profile + '/b2b/' + shortCode + '/students',
				),
			),
			tap((data: any) =>
				this.ngrxService.loadInitData('students', 'list', shortCode, [
					...data.data.map((d: any) => ({
						...d,
						userName: d.email.split('@')[0],
					})),
				]),
			),
		);
	}

	loadStudentData(shortCode: string) {
		return this.ngrxService.loadData('students', 'list', shortCode);
	}

	updatePassword(email: String, password: String) {
		return this.http.post(environment.url.profile + '/password/reset', {
			email,
			password,
		});
	}

	addStudents(content: any) {
		return this.http.post(environment.url.profile + '/create/v2', content).pipe(
			tap(() => {
				this.ngrxService.resetState('students', 'list', content.b2bFlag);
				this.loadStudentApi(content.b2bFlag).subscribe();
			}),
		);
	}

	updateOnboarding(email: string) {
		return this.http.put(
			environment.url.profile + `/onboarding/skip/user/${email}`,
			{
				email,
			},
		);
	}
	updateOnboardingFalse(user_id: string) {
		return this.http.post(
			environment.url.lookupBaseUrl +
				`/api/lookup/users/onboarding-skip
			`,
			{
				user_id,
				onboardingStatus: false,
			},
		);
	}
}
